import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { RECEIVE_WALLET_NAV } from '../constants/navigation'
import brandingService from '../services/branding'
import { BRANDING_FUNCTIONS } from '../store/actions/auth'
import WebLoading from '../components/shared/WebLoading/WebLoading'

class HomeContainer extends Component {

  componentDidMount() {
    if (brandingService.isBranding()) {
      const symbol = brandingService.getSymbol()
      this.props.storeBrandSymbol(symbol)
      this.props.getBrandData(symbol)
    } else {
      this.props.finishLoading()
    }
  }

  componentDidUpdate() {
    const { loading } = this.props

    if (!loading) {
      this.props.history.push(RECEIVE_WALLET_NAV)
    }
  }

  render() {
    return (
      <WebLoading />
    )
  }
}

const mapStateToProps = ({ authReducer }) => {  
  const { loading } = authReducer
  return {        
    loading,
  }
}

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    ...BRANDING_FUNCTIONS,
  }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer)


// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js